<template>
    <ContentOrLoading>
        <div v-if="products" class="row">
            <div class="col-12 col-lg-12">
                <div class="form-group">
                    <label for="products">PRODUCTOS ASOCIADOS AL EVENTO</label>
                    <ValidationProvider name="products" id="products" :rules="!products.length ? 'required' : ''" v-slot="{ errors }">
                        <multiselect
                            v-model="selected"
                            placeholder="Productos asociados al evento"
                            label="name"
                            track-by="id"
                            :options="products"
                            :multiple="false"
                            v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
                        />
                        <span v-if="errors[0]" class="error invalid-feedback d-block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import ContentOrLoading from "../components/ContentOrLoading";
    export default {
        props: {
            sga_event_id: {
                type: String,
                required: true
            },
            sga_product_id: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                products: [],
                selected: null
            }
        },
        mounted() {
            this.getProducts();
        },
        methods: {
            getProducts() {
                const data = {
                    filters: {
                        sga_event_id: this.sga_event_id
                    }
                }
                this.$store.dispatch(this.config.getVuexAlias('back.sga.events.products'), data).then(res => {
                    this.products = res.data.data;

                    if (this.sga_product_id) {
                        const preselectedProduct = this.products.find(product => product.id === this.sga_product_id);
                        if (preselectedProduct) {
                            this.selected = preselectedProduct;
                        }
                    }

                    else if (this.products.length === 1) {
                        this.selected = this.products[0];
                        this.$emit('selected', this.products[0]);
                    }
                });
            }
        },
        components: {
            ContentOrLoading
        }
    }
</script>
